import { Text } from "@clipboard-health/ui-components";
import { Box, Stack, type Theme } from "@mui/material";
import { CHARTING_CARD_IMAGE_PADDING } from "@src/appV2/redesign/Charting/constants";

interface BaseChartingCardProps {
  title: string;
  content?: React.ReactNode;
  footer?: React.ReactNode;
}

export function BaseChartingCard(props: BaseChartingCardProps) {
  const { title, content, footer } = props;
  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      gap={10}
      sx={{ minHeight: (theme: Theme) => theme.size?.shiftCard.minHeight }}
    >
      <Stack direction="column" gap={2}>
        <Text semibold variant="h4" textAlign="left">
          {title}
        </Text>
        <Box sx={{ maxWidth: `calc(100% - ${CHARTING_CARD_IMAGE_PADDING}px)` }}>{content}</Box>
      </Stack>
      {footer}
    </Stack>
  );
}
